<template>
  <div>
      <transition name="modalFade">
          <div v-if="calendarCreate" class="modalCalendarCreate">
            <CalendarCreate @closeCalendarCreateModal="closeCalendarCreateModal" @insertDataPeriods="insertDataPeriods" @editDataPeriods="editDataPeriods" :IsEdit="isEdit" :IdCalendarForEdit="idCalendarForEdit"></CalendarCreate>
          </div>
          <div v-if="calendarDetail" class="modalCalendarCreate">
            <CalendarDetail :IdCalendarForDetail="idCalendarForDetail" @closeCalendarDetailModal="closeCalendarDetailModal"></CalendarDetail>
          </div>
          <div v-if="calendarDelete" class="modalCalendarCreate">
            <CalendarDelete @closeCalendarDeleteModal="closeCalendarDeleteModal" @closeCalendarDeleteModalForYes="closeCalendarDeleteModalForYes" :IdCalendarForDelete="idCalendarForDelete"></CalendarDelete>
          </div>
      </transition>
      <div class="titlePage">Administración - Calendario Académico</div>
      <va-notification v-if="confirmationMessage" color="info">
        <p>Periodo y Programas Agregados Correctamente</p>
      </va-notification>
      <va-notification v-if="confirmationMessageEdit" color="info">
        <p>Periodo y Programas Editados Correctamente</p>
      </va-notification>
      <va-notification v-if="confirmationMessageDelete" color="info">
        <p>Periodo y Programas Eliminados Correctamente</p>
      </va-notification>
      <!--Componente que tiene la lógica que imprime la tabla en pantalla-->
      <TableList ref="table-list" :InfoView="tableData" :HeadTable="tableColumns" @callCreateModal="createModal" @editCalendar="editCalendar" @detailCalendar="detailCalendar" @deleteCalendar="deleteCalendar"/>
  </div>
</template>
  
<script>
//Importa el componente de Vuex
import IberoHelpers from '@/store/helpers.js'
//Importa el componente que tiene la lógica de la tabla que se imprime de Generic-Form
import TableList from '@/components/data-tables/DataCalendarioAcademico.vue'
//Importa el componente que contiene el formulario para la creación
import CalendarCreate from '@/components/CalendarioAcademico/FormularioNuevoCalendario.vue'
//Importa el componente que contiene el modal para el detalle de cada registro
import CalendarDetail from '@/components/CalendarioAcademico/DetalleCalendario.vue'
//Importa el componente que contiene el modal para eliminar cada registro
import CalendarDelete from '@/components/CalendarioAcademico/DeleteCalendario.vue'

  export default {
    components: {
        IberoHelpers,
        TableList,
        CalendarCreate,
        CalendarDetail,
        CalendarDelete
    },
    data () {
      return {
        calendarDelete: false,
        idCalendarForEdit: null,
        idCalendarForDetail: null,
        idCalendarForDelete: null,
        isEdit: null,
        confirmationMessage: false,
        confirmationMessageEdit: false,
        confirmationMessageDelete: false,
        calendarCreate: false,
        calendarDetail: false,
        tableData: [],
        tableColumns: [
            {
              name: 'periodoBanner',
              title: 'Periodo Banner',
              sortField: 'periodoBanner',
              dataClass: 'text-center',
              width: '1%',
            },
            {
              name: 'periodo',
              title: 'Periodo',
              sortField: 'periodo',
              dataClass: 'text-center',
              width: '1%',
            },
            {
              name: 'periodoAnterior',
              title: 'Periodo Anterior',
              sortField: 'periodoAnterior',
              dataClass: 'text-center',
              width: '1%',
            },
            {
              name: 'periodoSiguiente',
              title: 'Periodo Siguiente',
              sortField: 'periodoSiguiente',
              dataClass: 'text-center',
              width: '1%',
            },
            {
              name: 'fechaInicioPago',
              title: 'Fecha Inicio Pago',
              sortField: 'fechaInicioPago',
              dataClass: 'text-center',
              width: '5%',
            },
            {
              name: 'fechaInicioPeriodo',
              title: 'Fecha Inicio Periodo',
              sortField: 'fechaInicioPeriodo',
              dataClass: 'text-center',
              width: '5%',
            },
            {
              name: 'fechaCorte',
              title: 'Fecha Corte',
              sortField: 'fechaCorte',
              dataClass: 'text-center',
              width: '5%',
            },
            {
              name: 'fechaFinPago',
              title: 'Fecha Fin Pago',
              sortField: 'fechaFinPago',
              dataClass: 'text-center',
              width: '5%',
            },
            {
              name: 'fechaFinPeriodo',
              title: 'Fecha Fin Periodo',
              sortField: 'fechaFinPeriodo',
              dataClass: 'text-center',
              width: '5%',
            },
            {
              name: 'fechaInicioSiguientePeriodo',
              title: 'Fecha Inicio Siguiente Periodo',
              sortField: 'fechaInicioSiguientePeriodo',
              dataClass: 'text-center',
              width: '5%',
            },
            {
              name: '__slot:actionsThird',
              title: '',
              dataClass: 'text-center',
              width: '0%',
              actionRef: [
                {
                  label: 'OpenQuestion',
                  icon: 'fa-pencil',
                  action: 'question',
                },
              ],
            },
            {
              name: '__slot:actionsFirst',
              title: '',
              dataClass: 'text-center',
              width: '0%',
              actionRef: [
                {
                  label: 'Editar',
                  icon: 'fa-pencil',
                  action: 'edit',
                },
              ]
            },
            {
              name: '__slot:actionsSecond',
              title: '',
              dataClass: 'text-center',
              width: '0%',
              actionRef: [
                {
                  label: 'OpenQuestion',
                  icon: 'fa-pencil',
                  action: 'question',
                },
              ],
            },
            
        ],

      }
    },
    mounted () {
        //Llama el método que trae los datos de la tabla Calendario Permanencia
        this.loadData()
    },
    methods: {
        //Método para cargar los datos en la tabla 
        loadData () {
            //Llama el método en el Store, y usando axios se ejecuta el Get que trae la data
            IberoHelpers.GetCalendarPermanencia(this.$store, 0)
                .then(response => {
                    const formattedData = response.data.map(item => {
                        //Si la data llega null se coloca de esa manera en el array, y en las fechas quita la parte de la hora
                        item.fechaInicioPago = item.fechaInicioPago !== null ? item.fechaInicioPago.split('T')[0] : null; 
                        item.fechaInicioPeriodo = item.fechaInicioPeriodo !== null ? item.fechaInicioPeriodo.split('T')[0] : null;
                        item.fechaCorte = item.fechaCorte !== null ? item.fechaCorte.split('T')[0] : null;
                        item.fechaFinPago = item.fechaFinPago !== null ? item.fechaFinPago.split('T')[0] : null;
                        item.fechaFinPeriodo = item.fechaFinPeriodo !== null ? item.fechaFinPeriodo.split('T')[0] : null;
                        item.fechaInicioSiguientePeriodo = item.fechaInicioSiguientePeriodo !== null ? item.fechaInicioSiguientePeriodo.split('T')[0] : null;
                        //Cambia el booleano por strings
                        item.staActive = item.staActive !== null ? (item.staActive ? 'Activo' : 'Inactivo') : null;
                        return item;
                    });
                    this.tableData = formattedData;
                })
                .catch(error => {
                    console.error('Error loading data:', error);
                })
        },
        //Método para abrir el modal de creación de calendario
        createModal(){
            //Coloca en true la variable para mostrar el modal de creación
            this.calendarCreate = true;
            this.isEdit = false;
        },
        //Método para cerra el modal
        closeCalendarCreateModal(){
            //Coloca en false la variable para ocultar el modal de creación
            this.calendarCreate = false;
        },
        //Método para cerrar modal y actualizar la tabla despues de la inserción
        insertDataPeriods(){
            //Coloca en false la variable para ocultar el modal de creación
            this.calendarCreate = false;
            //Muestra la notifiación en un intervalo de tiempo
            setTimeout(()=>{
              this.confirmationMessage = true;
              setTimeout(()=>{
                this.confirmationMessage = false;
                this.tableUpdate();
              },3000);
            },200);
        },
        //Mé
        editDataPeriods(){
          //Coloca en false la variable para ocultar el modal de edición
          this.calendarCreate = false;
            //Muestra la notifiación en un intervalo de tiempo
            setTimeout(()=>{
              this.confirmationMessageEdit = true;
              setTimeout(()=>{
                this.confirmationMessageEdit = false;
                this.tableUpdate();
              },3000);
            },200);
        },
        //Actualiza la tabla de datos
        tableUpdate() {
          this.$refs['table-list'].updateTableData(this.loadData());
        },
        //Método para la edición de cada registro
        editCalendar(data){
          this.calendarCreate = true;
          this.isEdit = true;
          this.idCalendarForEdit = data.id;
        },
        //Método para mostrar el detalle de cada registro
        detailCalendar(data){
          this.calendarDetail = true;
          this.idCalendarForDetail = data.id;
        },
        //Método para cerrar el modal de detalle
        closeCalendarDetailModal(){
          this.calendarDetail = false;
        },
        //Método para mostrar el modal para eliminar registro
        deleteCalendar(data){
          this.calendarDelete = true;
          this.idCalendarForDelete = data.id;
        },
        //Método para cerrar el modal de eliminación
        closeCalendarDeleteModal(){
          this.calendarDelete = false;
        },
        //Método para cerrar el modal de eliminación después de dar a si
        closeCalendarDeleteModalForYes(){
          this.calendarDelete = false;
            //Muestra la notifiación en un intervalo de tiempo
            setTimeout(()=>{
              this.confirmationMessageDelete = true;
              setTimeout(()=>{
                this.confirmationMessageDelete = false;
                this.tableUpdate();
              },3000);
            },200);

        }
    },
  }
</script>